/* eslint-disable @typescript-eslint/no-explicit-any */
import { CheckPermissionsType } from 'src/types/checkPermissionsType'

let localprops = {
  language: 'en',
  country: 'US',
  mock: false,
  events: null,
  properties: {
    useOrgedAuthProvider: null
  }
}

export const setProps = (props) => {
  localprops = {
    ...localprops,
    ...props
  }
}

export const getProps = () => {
  return localprops
}

export const getDateandTime = () => {
  const today = new Date()
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  const month = months[today.getMonth()].substring(0, 3)
  const locale = 'en'
  const dateAndTime = `${month}${'\xa0'}${today.getDate()},
                ${today.toLocaleDateString(locale, {
                  year: 'numeric'
                })}${'\xa0'}${today.toLocaleTimeString(locale, {
                  hour: '2-digit',
                  hour12: true,
                  minute: '2-digit',
                  second: '2-digit'
                })}`
  return dateAndTime
}

export const checkAccessPermissions = async ({
  checkPermissions,
  scope,
  setResponse
}: CheckPermissionsType) => {
  try {
    const result = await checkPermissions(scope)
    setResponse(result)
  } catch (e) {
    console.error(e)
  }
}

export const setupPermissionChecker = (accessControl: any, scope: any[]) => {
  const mockCheckScopes = () => Promise.resolve(true)

  const isCheckScopes =
    typeof accessControl?.check === 'undefined' &&
    typeof accessControl?.checkScopes === 'function'

  const checkPermissions =
    (isCheckScopes
      ? accessControl?.checkScopes?.bind(accessControl)
      : accessControl?.check?.bind(accessControl)) || mockCheckScopes

  const formattedScope = isCheckScopes
    ? scope.map((s) => (typeof s === 'string' ? { scope: s } : s))
    : scope.map((s) => (typeof s === 'string' ? s : s.scope))

  return { checkPermissions, formattedScope }
}
